module.exports = __webpack_public_path__ + "img/demo.f9f64629.svg";